import React, { Suspense } from 'react'
// import qs from 'qs'
import { createStore } from 'zustand'
import { useCustomInfoSWR } from '@vt/apis/lib-ex/v2/login'

import SwrConfig from './swr-config'
import ProjectContext from './project-context'
// import { CustomStoreProvider } from '../stores/CustomStoreProvider'

// import '@ow/comps/dist/style.css'
// import '@ow/comps/dist/font.css'
// import '@ow/comps/dist/scrollbar.css'

// FIXME: 得抽取出去
// const getDefaultValue = () => {
//   const { token } = qs.parse(document.location.search.split('?')[1]) || {}
//   if (!token) {
//     return null
//   }
//   return { token }
// }

const Project = function ({
  children,
  vtProject,
  // createCustomStore,
  customCompsMap,
  customFieldsOperateConfig,
  customDetailConfig,
  cusKey = '',
  warpperRef,
}) {
  const finalCusKey = cusKey.replace('$', '')
  const isDebug = cusKey.indexOf('$') >= 0
  const { customInfo } = useCustomInfoSWR(finalCusKey)

  const store = createStore((set) => ({
    customInfo,
    isDebug,
    warpperRef,
    cusKey: finalCusKey,
    config: vtProject.config,
    token: vtProject.getToken(),
    customCompsMap,
    customFieldsOperateConfig,
    customDetailConfig,
    setUserInfo: (u) => {
      vtProject.setUserInfo(u)
      set({ userInfo: u })
    },
    getVtProject: () => vtProject,
    getToken: () => vtProject.getToken(),
    setToken: (t) => {
      vtProject.setToken(t)
      vtProject.setStorage({ key: 'token', data: t })
      set({ token: t })
    },
    setCustomCompsMap: (comps) => {
      set({ customCompsMap: comps })
    },
    setCustomFieldsOperateConfig: (customFields) => {
      set({ customFieldsOperateConfig: customFields })
    },
  }))

  return (
    <ProjectContext.Provider value={store}>
      <Suspense fallback={<div />}>
        <SwrConfig http={vtProject.http}>
          {/* <CustomStoreProvider createStore={createCustomStore}> */}
          {children}
          {/* </CustomStoreProvider> */}
        </SwrConfig>
      </Suspense>
    </ProjectContext.Provider>
  )
}
export default Project
